import { API_STATUS } from '../../../utilities/constants';
import manageReservationTypes from './manageReservation.types';

const INITIAL_STATE = {
  data: {},
  manageReservationApiStatus: API_STATUS.IDLE,
  errorMessage: null,
  packagesUpdated: null,
  cabanaApiStatus: API_STATUS.IDLE,
  cabanaErrorMessage: null,
  suiteUpgradeOffers: [],
  suiteUpgradeCurrentSuite: null,
  suiteUpgradeOffersStatus: API_STATUS.IDLE,
  suiteUpgradeOffersError: null,
  suiteUpgradePreview: null,
  suiteUpgradePreviewStatus: API_STATUS.IDLE,
  suiteUpgradePreviewError: null,
  suiteUpgradePreviewRequestToken: null,
  suiteUpgradeCommitStatus: API_STATUS.IDLE,
  suiteUpgradeCommitError: null,
  suiteUpgradeCommitErrorCode: null,
  isSuiteUpgraded: false
};

const manageReservationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_REQUEST:
      return { ...state, manageReservationApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_REQUEST:
      return { ...state, manageReservationApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.SUCCEEDED,
        data: { ...action.response },
        errorMessage: null,
        packagesUpdated: action?.packagesUpdated ?? null
      };
    case manageReservationTypes.GET_MANAGERESERVATIONDETAILS_FAILURE:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, data: {}, errorMessage: action.message };
    // we dispatch an error state but we ignore the error for addons
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_FAILURE:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        data: { ...state.data, ...action.response },
        errorMessage: null
      };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, errorMessage: action.message };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_CLEAR:
      delete state.addGuestsReservationObj;
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, errorMessage: null };
    case manageReservationTypes.UPDATE_RESERVATION_DETAILS_NEW_GUESTS_RESERVATION_ERROR_CLEAR:
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, errorMessage: null };

    case manageReservationTypes.GET_RESERVATION_BY_ID_AND_LAST_NAME_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        data: { ...state.data, ...action.response },
        errorMessage: null
      };
    case manageReservationTypes.FETCH_RESERVATION_ADD_ONS_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        upsellAddOns: action.response,
        errorMessage: null
      };

    case manageReservationTypes.CLEAR_MANAGERESERVATIONDETAILS:
      return { ...state, ...INITIAL_STATE };
    case manageReservationTypes.GET_COMPARISON_CHANGES_REQUEST:
      return { ...state, manageReservationApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.GET_COMPARISON_CHANGES_SUCCESS:
      return {
        ...state,
        manageReservationApiStatus: API_STATUS.IDLE,
        data: { ...state.data, comparisonChanges: action.response },
        errorMessage: null
      };
    case manageReservationTypes.GET_COMPARISON_CHANGES_FAILURE:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, data: {}, errorMessage: action.message };
    case manageReservationTypes.GET_COMPARISON_CHANGES_CLEAN:
      delete state.data.comparisonChanges;
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, data: { ...state.data }, errorMessage: null };
    case manageReservationTypes.CLEAR_RESERVATION_PACKAGES_UPDATE:
      return { ...state, manageReservationApiStatus: API_STATUS.IDLE, packagesUpdated: null, errorMessage: null };
    case manageReservationTypes.FETCH_RESERVATION_DYNAMIC_TILE_SUCCESS:
      return { ...state, dynamicTile: action.response };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_DETAILS_ERROR:
      return { ...state, errorMessage: null };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_IS_LOADING:
      return { ...state, cabanaApiStatus: API_STATUS.LOADING };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_SUCCESS:
      return { ...state, cabanaApiStatus: API_STATUS.SUCCEEDED };
    case manageReservationTypes.RESERVATION_DETAILS_CABANA_FAILURE:
      return { ...state, cabanaApiStatus: API_STATUS.ERROR, cabanaErrorMessage: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_CABANA_DETAILS:
      return { ...state, cabanaApiStatus: API_STATUS.IDLE, cabanaErrorMessage: null };
    case manageReservationTypes.PACKAGE_RESERVATION_LOADING_ERROR:
      return { ...state, manageReservationApiStatus: API_STATUS.ERROR, packageErrorMessageData: action.message };
    case manageReservationTypes.CLEAR_RESERVATION_DETAILS_PACKAGE_MESSAGE_ERROR:
      return { ...state, packageErrorMessageData: null };
    case manageReservationTypes.FETCH_RESERVATION_PERSONALIZE_ADDON:
      return { ...state, recommendedAddOns: action.response };
    case manageReservationTypes.CLEAR_CONFIRMATION_RECOMMENDATION:
      return { ...state, recommendedAddOns: null };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_OFFERS_REQUEST:
      return { ...state, suiteUpgradeOffersStatus: API_STATUS.LOADING, suiteUpgradeOffersError: null };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_OFFERS_SUCCESS:
      return {
        ...state,
        suiteUpgradeOffersStatus: API_STATUS.SUCCEEDED,
        suiteUpgradeOffers: action.response?.offerGroups ?? [],
        suiteUpgradeCurrentSuite: action.response?.currentSuite ?? null,
        suiteUpgradeOffersError: null
      };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_OFFERS_FAILURE:
      return {
        ...state,
        suiteUpgradeOffersStatus: API_STATUS.ERROR,
        suiteUpgradeOffers: INITIAL_STATE.suiteUpgradeOffers,
        suiteUpgradeCurrentSuite: INITIAL_STATE.suiteUpgradeCurrentSuite,
        suiteUpgradeOffersError: action.message
      };
    case manageReservationTypes.CLEAR_SUITE_UPGRADE_OFFERS:
      return {
        ...state,
        suiteUpgradeOffers: INITIAL_STATE.suiteUpgradeOffers,
        suiteUpgradeCurrentSuite: INITIAL_STATE.suiteUpgradeCurrentSuite,
        suiteUpgradeOffersStatus: API_STATUS.IDLE,
        suiteUpgradeOffersError: null
      };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_PREVIEW_REQUEST:
      return {
        ...state,
        suiteUpgradePreviewStatus: API_STATUS.LOADING,
        suiteUpgradePreview: INITIAL_STATE.suiteUpgradePreview,
        suiteUpgradePreviewError: null,
        suiteUpgradePreviewRequestToken: action.requestToken
      };
    // A preview response may only land if it belongs to the newest request. The guest can select
    // suite A, go back, and select suite B before A's preview resolves; A's late response must never
    // overwrite B's pricingKey/ruleId, which is what the commit step replays. Clearing nulls the
    // token, so a response arriving after the drawer closed is dropped by the same check.
    case manageReservationTypes.FETCH_SUITE_UPGRADE_PREVIEW_SUCCESS:
      if (action.requestToken !== state.suiteUpgradePreviewRequestToken) return state;
      return {
        ...state,
        suiteUpgradePreviewStatus: API_STATUS.SUCCEEDED,
        suiteUpgradePreview: action.response ?? INITIAL_STATE.suiteUpgradePreview,
        suiteUpgradePreviewError: null
      };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_PREVIEW_FAILURE:
      if (action.requestToken !== state.suiteUpgradePreviewRequestToken) return state;
      return {
        ...state,
        suiteUpgradePreviewStatus: API_STATUS.ERROR,
        suiteUpgradePreview: INITIAL_STATE.suiteUpgradePreview,
        suiteUpgradePreviewError: action.message
      };
    case manageReservationTypes.CLEAR_SUITE_UPGRADE_PREVIEW:
      return {
        ...state,
        suiteUpgradePreview: INITIAL_STATE.suiteUpgradePreview,
        suiteUpgradePreviewStatus: API_STATUS.IDLE,
        suiteUpgradePreviewError: null,
        suiteUpgradePreviewRequestToken: INITIAL_STATE.suiteUpgradePreviewRequestToken
      };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_COMMIT_REQUEST:
      return {
        ...state,
        suiteUpgradeCommitStatus: API_STATUS.LOADING,
        suiteUpgradeCommitError: null,
        suiteUpgradeCommitErrorCode: null
      };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_COMMIT_SUCCESS:
      return {
        ...state,
        suiteUpgradeCommitStatus: API_STATUS.SUCCEEDED,
        suiteUpgradeCommitError: null,
        suiteUpgradeCommitErrorCode: null
      };
    case manageReservationTypes.FETCH_SUITE_UPGRADE_COMMIT_FAILURE:
      return {
        ...state,
        suiteUpgradeCommitStatus: API_STATUS.ERROR,
        suiteUpgradeCommitError: action.message,
        suiteUpgradeCommitErrorCode: action.code ?? null
      };
    case manageReservationTypes.SET_SUITE_UPGRADED:
      return { ...state, isSuiteUpgraded: true };
    case manageReservationTypes.CLEAR_SUITE_UPGRADE_COMMIT:
      return {
        ...state,
        suiteUpgradeCommitStatus: API_STATUS.IDLE,
        suiteUpgradeCommitError: null,
        suiteUpgradeCommitErrorCode: null
      };
    default:
      return state;
  }
};

export default manageReservationReducer;
